module.exports = {
  PRIMARY: 'primary',
  POSITIVE: 'positive',
  MP_ANDES_BLUE_500: '#009EE3',
  MP_ANDES_YELLOWBLUE_500: '#3483FA',
  SECONDARY: 'secondary',
};

